import React, { useState, useRef } from 'react';
export const TooltipProvider = ({
  children
}) => {
  return <>{children}</>;
};
export const Tooltip = ({
  children
}) => {
  return <div className="relative inline-flex" data-id="element-682">{children}</div>;
};
export const TooltipTrigger = ({
  className = '',
  children,
  ...props
}) => {
  return <span className={`cursor-help inline-flex items-center ${className}`} {...props} data-id="element-683">
      {children}
    </span>;
};
export const TooltipContent = ({
  className = '',
  children
}) => {
  return <div className={`absolute z-50 p-3 bg-gray-800 text-white text-xs rounded-lg shadow-lg max-w-xs -translate-y-full -mt-2 left-1/2 -translate-x-1/2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-200 ${className}`} data-id="element-684">
      {children}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-2 h-2 bg-gray-800 rotate-45" data-id="element-685"></div>
    </div>;
};
export const InfoTooltip = ({
  content
}) => {
  return <Tooltip data-id="element-686">
      <TooltipTrigger className="group relative" data-id="element-687">
        <span className="w-4 h-4 flex items-center justify-center rounded-full bg-gray-200 text-gray-600 text-[10px] ml-1 hover:bg-gray-300 transition-colors" data-id="element-688">
          ?
        </span>
        <TooltipContent data-id="element-689">{content}</TooltipContent>
      </TooltipTrigger>
    </Tooltip>;
};